<template>
  <div>
    <div class="header">
    <h1>이레에비던스</h1>
    <h3>이레에비던스는 사용자 편리를 위해 아이디어를 찾아 앱을 제공합니다</h3>
    </div>
    <div class="content">

      <div class="app-row">
        <div class="app-row__head">
          <div class="app-title">기기 충전시 열기</div>
          <button @click="openPrivacyTurnOn()">개인정보 처리방침</button>
        </div>
        <div class="app-discription">기기를 충전할 때 홈 화면을 열어주는 기능을 수행합니다</div>
      </div>

      <div class="app-row">
        <div class="app-row__head">
          <div class="app-title">Micker</div>
          <button @click="openPrivacyMicker()">개인정보 처리방침</button>
        </div>
        <div class="app-discription">기기의 음성 장비를 선택하여 음성을 입력, 출력을 제어하는 앱입니다</div>
      </div>

      <div class="app-row">
        <div class="app-row__head">
          <div class="app-title">Auto Launcher</div>
          <button @click="openPrivacyAutoLauncher()">개인정보 처리방침</button>
        </div>
        <div class="app-discription">기기의 충전 시작/중지에 따라 앱을 열고 종료하는 기능을 수행하는 앱입니다</div>
      </div>

      <div class="app-row">
        <div class="app-row__head">
          <div class="app-title">Deleting App</div>
          <button @click="openPrivacyAppDelete()">개인정보 처리방침</button>
        </div>
        <div class="app-discription">기기 내 설치된 앱을 조회하고 일괄적으로 제거하는 앱입니다</div>
      </div>

      <div class="app-row">
        <div class="app-row__head">
          <div class="app-title">Settings Shortcut</div>
          <button @click="openPrivacySettingsShortcut()">개인정보 처리방침</button>
        </div>
        <div class="app-discription">설정의 바로가기 기능과 위젯을 제공합니다</div>
      </div>

      <div class="app-row">
        <div class="app-row__head">
          <div class="app-title">Charging Complete Alert</div>
          <button @click="openPrivacyBatteryChargeAlarm()">개인정보 처리방침</button>
        </div>
        <div class="app-discription">기기의 배터리 충전/방전시 사용자에게 알려줍니다</div>
      </div>

      <div class="app-row">
        <div class="app-row__head">
          <div class="app-title">NotiCatch</div>
          <button @click="openPrivacyNotiCatch()">개인정보 처리방침</button>
        </div>
        <div class="app-discription">여러 앱의 알림을 하나의 받은편지함으로 모아 검색·관리할 수 있게 해주는 앱입니다</div>
      </div>

      <div class="app-row">
        <div class="app-row__head">
          <div class="app-title">ScanRay</div>
          <button @click="openPrivacyScanRay()">개인정보 처리방침</button>
        </div>
        <div class="app-discription">QR 코드와 바코드를 카메라로 즉시 인식하고 히스토리에 자동 저장하는 앱입니다</div>
      </div>

      <div class="app-row">
        <div class="app-row__head">
          <div class="app-title">WhiteNoise</div>
          <button @click="openPrivacyWhiteNoise()">개인정보 처리방침</button>
        </div>
        <div class="app-discription">비·파도·바람·카페·화이트노이즈 등 사운드를 즉시 재생해 수면·공부·집중을 보조하는 앱입니다</div>
      </div>

      <div class="app-row">
        <div class="app-row__head">
          <div class="app-title">AxisTrue</div>
          <button @click="openPrivacyAxisTrue()">개인정보 처리방침</button>
        </div>
        <div class="app-discription">수평계와 나침반을 하나의 다이얼에 합쳐 평평한지와 방위를 한눈에 확인하는 앱입니다</div>
      </div>

      <div class="app-row">
        <div class="app-row__head">
          <div class="app-title">UnitShift</div>
          <button @click="openPrivacyUnitShift()">개인정보 처리방침</button>
        </div>
        <div class="app-discription">길이·무게·온도·통화·요리 등 다양한 단위를 빠르게 변환하는 앱입니다</div>
      </div>

      <div class="app-row">
        <div class="app-row__head">
          <div class="app-title">DocScan</div>
          <button @click="openPrivacyDocScan()">개인정보 처리방침</button>
        </div>
        <div class="app-discription">문서·영수증을 카메라로 스캔해 자동 보정하고 PDF로 저장하는 앱입니다</div>
      </div>

      <div class="app-row">
        <div class="app-row__head">
          <div class="app-title">Photo Compact</div>
          <button @click="openPrivacyPhotoCompact()">개인정보 처리방침</button>
        </div>
        <div class="app-discription">사진을 원하는 용량 이하로 압축해 첨부·전송을 쉽게 해주는 앱입니다</div>
      </div>

      <div class="app-row">
        <div class="app-row__head">
          <div class="app-title">TextScan</div>
          <button @click="openPrivacyTextScan()">개인정보 처리방침</button>
        </div>
        <div class="app-discription">사진·카메라 속 글자를 텍스트로 추출해 복사·공유하는 앱입니다</div>
      </div>

      <div class="app-row">
        <div class="app-row__head">
          <div class="app-title">PDF Merge</div>
          <button @click="openPrivacyPdfMerge()">개인정보 처리방침</button>
        </div>
        <div class="app-discription">여러 PDF를 하나로 합치고 페이지를 추출·분할하는 앱입니다</div>
      </div>

      <div class="app-row">
        <div class="app-row__head">
          <div class="app-title">Image Convert</div>
          <button @click="openPrivacyImgConvert()">개인정보 처리방침</button>
        </div>
        <div class="app-discription">HEIC·JPG·PNG·WEBP 이미지 포맷을 오프라인으로 변환하는 앱입니다</div>
      </div>

      <div class="app-row">
        <div class="app-row__head">
          <div class="app-title">Hangul Obfuscator</div>
          <button @click="openPrivacyHangulNandokgi()">개인정보 처리방침</button>
        </div>
        <div class="app-discription">한글 문장을 사람만 읽을 수 있게 난독화해 변환하는 앱입니다</div>
      </div>

    </div>
    <footer>
      <span class="footer-head">COMPANY</span>
      <span class="footer-body">이레에비던스</span>
      <span class="footer-head">REPRESENTIVE</span>
      <span class="footer-body">윤기쁨</span>
      <span class="footer-head">E-MAIL</span>
      <span class="footer-body">evidence.erae@gmail.com</span>
      <span class="footer-head">TEL</span>
      <span class="footer-body">010-7901-1240</span>
      <p style="font-size: 14px; color: #555555">&copy; Erae Evidence. All rights reserved.</p>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  methods:{
    openPrivacyTurnOn() {
      this.$router.push('/privacy/turn-on')
    },
    openPrivacyMicker() {
      this.$router.push('/privacy/micker')
    },
    openPrivacyAutoLauncher() {
      this.$router.push('/privacy/auto-launcher')
    },
    openPrivacyAppDelete() {
      this.$router.push('/privacy/app-delete')
    },
    openPrivacySettingsShortcut() {
      this.$router.push('/privacy/settings-shortcut')
    },
    openPrivacyBatteryChargeAlarm() {
      this.$router.push('/privacy/battery-charge-alarm')
    },
    openPrivacyNotiCatch() {
      this.$router.push('/privacy/noti-catch')
    },
    openPrivacyScanRay() {
      this.$router.push('/privacy/scan-ray')
    },
    openPrivacyWhiteNoise() {
      this.$router.push('/privacy/white-noise')
    },
    openPrivacyAxisTrue() {
      this.$router.push('/privacy/axis-true')
    },
    openPrivacyUnitShift() {
      this.$router.push('/privacy/unit-shift')
    },
    openPrivacyDocScan() {
      this.$router.push('/privacy/doc-scan')
    },
    openPrivacyPhotoCompact() {
      this.$router.push('/privacy/photo-compact')
    },
    openPrivacyTextScan() {
      this.$router.push('/privacy/text-scan')
    },
    openPrivacyPdfMerge() {
      this.$router.push('/privacy/pdf-merge')
    },
    openPrivacyImgConvert() {
      this.$router.push('/privacy/img-convert')
    },
    openPrivacyHangulNandokgi() {
      this.$router.push('/privacy/hangul-nandokgi')
    }
  },
  data() {
    return {}
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.header {
  width: 100%;
  background-color: #eeeeee;
  padding-top: 60px;
  padding-bottom: 30px;
}

.content {
  border-radius: 10px;
  margin: 30px;
  border: 2px solid #ffffff;
  background-color: #ffffff;
  padding: 20px 30px 40px 30px;
  display: flex;
  flex-direction: column;
}

.app-row {
  padding: 20px 0;
  border-bottom: 1px solid #eeeeee;
  text-align: left;
}

.app-row:last-child {
  border-bottom: none;
}

.app-row__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.app-title {
  font-size: 20px;
  color: #333333;
  font-weight: bold;
}

.app-discription {
  font-size: 16px;
  color: #555555;
  padding-top: 8px;
}

.footer-head {
  font-size: 14px;
  color: #777777;
  margin-left: 4px;
  margin-right: 4px;
}

.footer-body {
  font-size: 14px;
  color: #555555;
  margin-left: 4px;
  margin-right: 4px;
}

button {
  border-radius: 10px;
  background-color: #e0e0e0;
  display: inline-block;
  padding: 8px 20px 8px 20px;
  color: #000000;
  font-weight: bold;
  text-align: center;
  white-space: nowrap;
}

h1 {
  text-align: center;
}

h2 {
  text-align: left;
  font-size: 13px;
  color: #ffffff;
  padding-bottom: 15px;
}

h3 {
  text-align: center;
  margin: 3px 0 0;
}

h4 {
  text-align: left;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

</style>
